import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagModeratorProps {}

const ColorTagModerator: React.FC<ColorTagModeratorProps> = props => {
  return <ColorTag className="ColorTagModerator" color="skyblue" appearance="translucent">Moderator</ColorTag>
}

export default ColorTagModerator;